export const environment = {
  baseUrl: 'https://dev.api.salonfriday.com',
  refreshTokenExpMinutes: 117,
};
